<template>
  <div id="thank-you-page">
    <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
    <!-- <a v-if="showReviewThanks" href="/write-a-review"><img class="valentines-banner is-hidden-mobile" alt="Valentine's campaign" src="/static/img/valentines/v-thanks-desktop.png" srcset="/static/img/valentines/v-thanks-desktop.png 1x, /static/img/valentines/v-thanks-desktop@2x.png 1.5x, /static/img/valentines/v-thanks-desktop@2x.png 2x, /static/img/valentines/v-thanks-desktop@3x.png 3x" /></a> -->
    <article class="media is-hidden-mobile" v-if="showReviewThanks">
      <div class="media-left">
        <figure class="image">
          <img alt="Thank you for your review" class="thanks" src="/static/img/reviews/review-thanks.png"
               srcset="/static/img/reviews/review-thanks@2x.png 2x, /static/img/reviews/review-thanks@3x.png 3x"/>
        </figure>
      </div>
      <div class="media-content">
        <div class="content">
          <p>{{ thankYouText }}</p>
        </div>
      </div>
    </article>
    <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
    <div class="is-hidden-mobile">
      <div class="desktop-review-container">
        <review-card :attachments="review.attachments"
                     :author="review.author"
                     :author-avatar="review.authorAvatar"
                     :author-id="review.author_id"
                     :business="review.business_name"
                     :business-slug="review.business_slug"
                     :is-thank-you-card="isThankYouCard"
                     :review-blurb="review.review_content"
                     :review-date="review.created_at"
                     :review-rating="review.review_rating"
                     :review-slug="review.permalink"
                     :review-title="review.review_title"
                     author-avatar-color="#39887C"
                     :consumer-comp="consumerCompetitions"
        ></review-card>
      </div>
    </div>
    <!-- MOBILE -->
    <!-- <img class="valentines-banner is-hidden-tablet" alt="Valentine's campaign" src="/static/img/valentines/v-mobile.png" srcset="/static/img/valentines/v-mobile.png 1x, /static/img/valentines/v-mobile@2x.png 1.5x, /static/img/valentines/v-mobile@2x.png 2x, /static/img/valentines/v-mobile@3x.png 3x" /> -->
    <div class="columns is-hidden-tablet mobile-thank-you" v-if="showReviewThanks">
      <div class="column has-text-centered is-paddingless">
        <img alt="Thank you for your review" class="thanks" src="/static/img/reviews/review-thanks.png"
             srcset="/static/img/reviews/review-thanks@2x.png 2x, /static/img/reviews/review-thanks@3x.png 3x"/>
      </div>
      <div class="column is-paddingless">
        <p class="has-text-centered has-text-weight-bold thanks-text">{{ thankYouText }}</p>
      </div>
    </div>
    <p v-if="isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd"></ad>
    </p>
    <div class="is-hidden-tablet">
      <review-card :attachments="review.attachments"
                   :author="review.author"
                   :author-avatar="review.authorAvatar"
                   :author-id="review.author_id"
                   :business="review.business_name"
                   :business-slug="review.business_slug"
                   :is-thank-you-card="isThankYouCard"
                   :review-blurb="review.review_content"
                   :review-date="review.created_at"
                   :review-rating="review.review_rating"
                   :review-slug="review.permalink"
                   :review-title="review.review_title"
                   :consumer-comp="consumerCompetitions"
                   author-avatar-color="#39887C"></review-card>
    </div>
    <div id="featured-reviews-container">
      <section class="section featured-reviews">
        <p class="has-text-centered spinner" v-if="reviews_loading"><img alt="Loading reviews"
                                                                         src="/static/img/others/spinner.svg"/></p>
        <p class="has-text-centered what-others-are-saying" v-html="whatOthersAreSaying" v-if="!reviews_loading"></p>
        <div class="columns is-multiline" v-if="!reviews_loading">
          <div class="column is-hidden-mobile is-full-tablet is-half-desktop"
               v-for="(reviewItem, index) in featuredReviews">
            <review-card :attachments="review.attachments"
                         :author="reviewItem.author"
                         :author-avatar="reviewItem.authorAvatar"
                         :author-avatar-color="backgroundColors[index]"
                         :author-id="reviewItem.author_id"
                         :business="reviewItem.business_name"
                         :business-slug="reviewItem.business_slug"
                         :review-blurb="reviewItem.review_content"
                         :review-date="reviewItem.created_at"
                         :review-rating="reviewItem.review_rating"
                         :review-slug="reviewItem.permalink"
                         :review-title="reviewItem.review_title"></review-card>
          </div>
          <div class="column is-paddingless is-hidden-tablet is-fullwidth mobile-column"
               v-for="(reviewItem, index) in featuredReviews">
            <review-card :attachments="review.attachments"
                         :author="reviewItem.author"
                         :author-avatar="reviewItem.authorAvatar"
                         :author-avatar-color="backgroundColors[index]"
                         :author-id="reviewItem.author_id"
                         :business="reviewItem.business_name"
                         :business-slug="reviewItem.business_slug"
                         :review-blurb="reviewItem.review_content"
                         :review-date="reviewItem.created_at"
                         :review-rating="reviewItem.review_rating"
                         :review-slug="reviewItem.permalink"
                         :review-title="reviewItem.review_title"></review-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import ReviewCard from '@/components/ReviewCard'
import adsConfig from '@/mixins/ad_config'
import Ad from '@/components/ProgrammaticAds'

export default {
  name: 'ThankYou',
  components: {
    ReviewCard, Ad
  },
  mixins: [adsConfig],
  metaInfo: {
    title: 'Thank you for your review'
  },
  data () {
    return {
      thankYouText: 'Thank you for your review!',
      review: {},
      isThankYouCard: true,
      showReviewThanks: false,
      reviews_loading: true,
      featuredReviews: [],
      backgroundColors: [
        '#88397F',
        '#394B88',
        '#39887C',
        '#885A39',
        '#88397F',
        '#394B88',
        '#39887C',
        '#885A39'
      ]
    }
  },
  created () {
    const storedReview = localStorage.getItem('new_review')
    if (typeof storedReview === 'string' && storedReview.length > 0) {
      this.review = JSON.parse(storedReview)
      this.review.review_rating = parseInt(this.review.review_rating)
      this.showReviewThanks = true
      if (typeof this.review.business_name !== 'undefined' && typeof this.review.industry_name !== 'undefined') {
        this.$gtm.trackEvent({
          event: 'conversionSuccess',
          type: 'ConsumerReview',
          brandName: this.review.business_name,
          industryName: this.review.industry_name,
          rating: this.review.review_rating
        })
      }
      this.getFeaturedReviews()
    }
  },
  mounted () {
    this.loadAds()
  },
  computed: {
    consumerCompetitions () {
      if ('consumerCompetitions' in this.review) {
        return this.review.consumerCompetitions
      }
      return []
    },
    whatOthersAreSaying () {
      if (!this.showReviewThanks) {
        return ''
      }
      return `Other reviews in <span class="has-text-weight-bold">${this.review.industry_name}</span>`
    }
  },
  methods: {
    getFeaturedReviews () {
      this.reviews_loading = true
      axios.get(`/consumer/latest-reviews/${this.review.permalink}`)
        .then(({data}) => {
          this.featuredReviews = data
          this.reviews_loading = false
        })
        .catch(() => {
          this.reviews_loading = false
        })
    }
  }
}
</script>
<style scoped>

#thank-you-page {
  padding-top: 0.1rem;
}

article.media {
  max-width: 550px;
  margin: 40px auto;
}

.media-content > .content > p {
  color: #58595B;
  font-size: 2rem;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
}

.media-left {
  margin-right: 1.5rem;
}

.thanks {
  width: 60px;
  height: 60px;
}

.thanks-text {
  color: #58595B;
  font-size: 1.3rem;
}

#featured-reviews-container {
  background-color: #F5F5F5;
}

.featured-reviews {
  max-width: 1125px;
  margin: 0 auto;
  padding: 4rem 0;
}

.what-others-are-saying {
  font-size: 1.4rem;
  margin-bottom: 3rem;
}

.desktop-review-container {
  max-width: 1125px;
  margin: 0 auto;
  padding-top: 0;
  padding-bottom: 4rem;
}

@media screen and (max-width: 1024px) {
  .desktop-review-container, #featured-reviews-container {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media screen and (max-width: 767px) {
  .thanks {
    width: 40px;
    height: 40px;
  }

  .mobile-thank-you {
    margin-top: 1.5rem;
    margin-bottom: 2rem;
  }

  .desktop-review-container, #featured-reviews-container {
    padding-left: 0;
    padding-right: 0;
  }

  .what-others-are-saying {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .columns > .mobile-column {
    margin-bottom: 1rem;
  }

  .columns > .mobile-column:last-child {
    margin-bottom: 0;
  }

  .card {
    border-bottom: 1px solid #C9C9C9 !important;
  }

}

.valentines-banner {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/reviews/Thanks.vue